<template>
  <div>
    <v-navigation-drawer
      class="navbars--side"
      v-model="drawer"
      absolute
      temporary
    >
      <v-list-item class="navbars--side__head">
        <v-img max-width="50" src="@/assets/img/logo.png"></v-img>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item v-for="item in items" :key="item" link>
          <v-list-item-content>
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list class="navbars--side__foot">
        <v-list-item class="black--text">
          <v-menu open-on-hover offset-y transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text class="navbars--title" dark v-bind="attrs" v-on="on">
                En/Id
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in language" :key="index">
                <v-list-item-title>{{ item.lang }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item>
        <v-list-item>
          <v-menu
            open-on-hover
            offset-y
            transition="slide-y-transition"
            bottom
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <v-text-field placeholder="Search" solo></v-text-field>
          </v-menu>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar class="navbars" elevation="4" height="80" dense fixed>
      <v-container>
        <v-row align="center">
          <v-toolbar-title class="text-uppercase">
            <v-img
              max-width="50"
              lazy-src="@/assets/img/logo.png"
              src="@/assets/img/logo.png"
            ></v-img>
          </v-toolbar-title>
          <v-spacer />
          <v-app-bar-nav-icon
            v-if="isXs"
            @click.stop="drawer = !drawer"
            color="white"
          ></v-app-bar-nav-icon>
          <div v-else>
            <v-btn to="/" text class="navbars--title navbars--title__nav">
              <span>Beranda</span>
            </v-btn>
            <v-btn
              @click="goTo('#about')"
              text
              class="navbars--title navbars--title__nav"
            >
              <span>Tentang</span>
            </v-btn>
            <v-btn
              @click="goTo('#feature')"
              text
              class="navbars--title navbars--title__nav"
            >
              <span>Fitur</span>
            </v-btn>
            <v-btn
              @click="goTo('#collection')"
              text
              class="navbars--title navbars--title__nav"
            >
              <span>Koleksi</span>
            </v-btn>
            <v-btn
              @click="goTo('#venue')"
              text
              class="navbars--title navbars--title__nav"
            >
              <span>Virtual Venue</span>
            </v-btn>
            <v-menu
              open-on-hover
              offset-y
              transition="slide-y-transition"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  class="navbars--title"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  En/Id
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in language" :key="index">
                  <v-list-item-title>{{ item.lang }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu
              open-on-hover
              offset-y
              transition="slide-y-transition"
              bottom
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <v-text-field placeholder="Search" solo></v-text-field>
            </v-menu>
          </div>
        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      drawer: null,
      isXs: false,
      language: [
        {
          lang: "English"
        },
        {
          lang: "Bahasa Indonesia"
        }
      ],
      items: ["Home", "About", "Feature", "Collection"]
    };
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
    goTo(id) {
      if(this.$route.name !== 'Home') {
        this.$router.replace({path: `/${id}`})
      } else {
        const el = document.querySelector(id);
        el && el.scrollIntoView();
      }
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
